import { render } from "./e-shop-status.vue?vue&type=template&id=2b23020c&ts=true"
import script from "./e-shop-status.vue?vue&type=script&lang=ts"
export * from "./e-shop-status.vue?vue&type=script&lang=ts"

import "./e-shop-status.vue?vue&type=style&index=0&id=2b23020c&lang=scss"

import exportComponent from "/Users/brian/VIS Solutions/aeon-boxed-middleware-spa/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__